<template>
  <div
    class="position-absolute right-0 top-0 mt-2 mr-2"
  >
    <DropdownMenu>
      <DropdownMenuTrigger
        class="btn btn-light btn-icon btn-xs"
      >
        <i class="fa-solid fa-ellipsis" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          as="a"
          target="_blank"
          :href="teamAsset.real_url"
          class="tw:text-foreground"
        >
          View
        </DropdownMenuItem>
        <DropdownMenuItem @select="copyUrl">
          Copy URL
        </DropdownMenuItem>
        <DropdownMenuItem @select="startRenaming">
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem @select="startSharing">
          Share Settings
        </DropdownMenuItem>
        <DropdownMenuItem @select="deleteTeamAsset(teamAsset)">
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script setup>
import { useClipboard } from '@vueuse/core'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shadcn/components/ui/dropdown-menu'
import { useTeamAssetItem } from './use-team-asset-item'
import { useTeamAssets } from './use-team-assets'

const { teamAsset, toggleIsRenaming } = useTeamAssetItem()
const { deleteTeamAsset, teamAssetSharingFormRef } = useTeamAssets()
const { copy } = useClipboard()

function startSharing() {
  if (teamAssetSharingFormRef.value) {
    teamAssetSharingFormRef.value.startSharing(teamAsset.value)
  }
}

function startRenaming() {
  toggleIsRenaming(true)
}

function copyUrl() {
  copy(teamAsset.value.forwarder_url).then(() => {
    window.SwalTimer.fire({
      icon: 'success',
      title: 'Copied to Clipboard',
    })
  })
}
</script>
